import React from 'react';
// import styled from 'styled-components'
import PropTypes from 'prop-types'

import {Box, Heading} from 'rebass';
import {Content, MobileHeader} from "../../components/Base";
import FacultySettings from './FacultySettings'
import StudentSettings from './StudentSettings'
 
const Settings = (props) => {

	const {
		school, profile, isFaculty, updateInterests, updateRequestNotification,
		handleSubmitLeaveType, handleSubmitTransport, handleSubmitLocation, handleSubmitInterest, handleSubmitStudent, handleSubmitFaculty, handleSubmitParent,
		handleUpdateLeaveType, handleUpdateTransport, handleUpdateLocation, handleUpdateInterest, handleUpdateStudent, handleUpdateFaculty,	handleUpdateParent,
		leaveTypes, transportation, locations, interests, students, faculties, parents
	} = props;

	return (
		<Box>

			<MobileHeader>
				<Heading py={2} color={'black'}>Settings</Heading>
			</MobileHeader>
			<Content pt={[0]} px={2}>

					{isFaculty ?
						<FacultySettings
							school={school}
							profile={profile}
							updateRequestNotification={updateRequestNotification}
							locations={locations}
							interests={interests}
							transportation={transportation}
							leaveTypes={leaveTypes}
							students={students}
							faculties={faculties}
							parents={parents}
							handleSubmitLeaveType={handleSubmitLeaveType}
							handleSubmitLocation={handleSubmitLocation}
							handleSubmitTransport={handleSubmitTransport}
							handleSubmitInterest={handleSubmitInterest}
							handleSubmitStudent={handleSubmitStudent}
							handleSubmitFaculty={handleSubmitFaculty}
							handleSubmitParent={handleSubmitParent}
							handleUpdateInterest={handleUpdateInterest}
							handleUpdateLeaveType={handleUpdateLeaveType}
							handleUpdateLocation={handleUpdateLocation}
							handleUpdateTransport={handleUpdateTransport}
							handleUpdateStudent={handleUpdateStudent}
							handleUpdateFaculty={handleUpdateFaculty}
							handleUpdateParent={handleUpdateParent}
						/>
						:
						<StudentSettings
							school={school}
							profile={profile}
							updateInterests={updateInterests}
							updateRequestNotification={updateRequestNotification}
						/>
					}
			</Content>
		</Box>
	)
}

Settings.propTypes = {
	school: PropTypes.object,
	profile: PropTypes.object,
	isFaculty: PropTypes.bool,
	updateInterests: PropTypes.func,
	updateRequestNotification: PropTypes.func,

	// ConfigurationPanel Props
	handleSubmitLeaveType: PropTypes.func,
	handleSubmitTransport: PropTypes.func,
	handleSubmitLocation: PropTypes.func,
	handleSubmitInterest: PropTypes.func,
	handleSubmitStudent: PropTypes.func,
	handleSubmitFaculty: PropTypes.func,
	handleSubmitParent: PropTypes.func,
	handleUpdateLeaveType: PropTypes.func,
	handleUpdateTransport: PropTypes.func,
	handleUpdateLocation: PropTypes.func,
	handleUpdateInterest: PropTypes.func,
	handleUpdateStudent: PropTypes.func,
	handleUpdateFaculty: PropTypes.func,
	handleUpdateParent: PropTypes.func,
	leaveTypes: PropTypes.array,
	transportation: PropTypes.array,
	locations: PropTypes.array,
	interests: PropTypes.array,
	parents: PropTypes.array
};

Settings.defaultProps = {
	isFaculty: false,

	// ConfigurationPanel Props
	// handleSubmitLeaveType: (values) => console.log(values),
	// handleSubmitTransport: (values) => console.log(values),
	// handleSubmitLocation: (values) => console.log(values),
	// handleSubmitInterest: (values) => console.log(values),
	// handleUpdateLeaveType: (values) => console.log(values),
	// handleUpdateTransport: (values) => console.log(values),
	// handleUpdateLocation: (values) => console.log(values),
	// handleUpdateInterest: (values) => console.log(values)
};

export default Settings



